import React from "react";
import type { FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

export const faIcon = (icon: IconDefinition, extraProps?: Partial<FontAwesomeIconProps>) => (
    <FontAwesomeIcon icon={icon} fixedWidth {...extraProps} />
);
